//NOTE - set cxGlobal.initData.cLogger.disableLogger: true to only log to the console and not send to the server
import * as jsnlog from "jsnlog";
window.JL = jsnlog.JL; //expose for external usasge like in BindGlobalAjaxSettings.js.
export function AttachLogger()
{
    //if (typeof (jsnlog.JL) !== "undefined") {
        jsnlog.JL.setOptions({
            "requestId": cxGlobal.initData.cLogger.requestId,
            "defaultAjaxUrl": cxGlobal.initData.cLogger.loggerUrl,
            "defaultBeforeSend": function (xhr) {
                xhr.setRequestHeader("UnixDates", "true");
                xhr.setRequestHeader(cxCsrf.headerKey, Cookies.get(cxCsrf.formCookieKey));
            }
        });
    //}
    //else {
    //    jsnlog.JL = false;
    //    //ADBlockers might block jsnlog, and this is the first script that's beeing blocked so this is the right place to deal with it, send log message to the server in the format that jsnlog sends
    //    logErrorWithNoLogger({"logAsDebug": true, msg:"jsnlog was blocked by an AdBlocker, probably uBlock, possible error: ERR_BLOCKED_BY_CLIENT"});
    //    try {
    //        showMsg({
    //            msg: "Candex cannot load properly due to AdBlock.<br />Use a different browser or allow www.candex.com on AdBlock.<br />Contact <a href='mailto:support@candex.com'>support@candex.com</a> for help.",
    //            attention: true,
    //            isHtml: true,
    //            wideMsg: true
    //        });
    //    } catch (e) {
    //        console.log("%cCandex cannot load properly due to AdBlock.\nUse a different browser or allow www.candex.com on AdBlock.","color: red");
    //    }
    //}
    
    window.onerror = function(errorMsg, url, lineNumber, column, errorObj)
    {
        if (shouldIgnoreeClientError(errorMsg, url, lineNumber, column, errorObj)) {
            return false;
        }
        logError(errorMsg, url, lineNumber, column, errorObj);
        return false;
    };
    //NOTE - this will not be fired in IE
    window.onunhandledrejection = function (event) {
        event.preventDefault();
        //NOTE throw "some message" => event.reason is the string with the error
        //     throw new Error() =>  event.reason is an object with stacktrace and no message
        //     in "normal" exceptions event.reason is an object with stacktrace and a message
        var eventMsg = `${event.reason ? typeof event.reason === "string" ? event.reason : event.reason.message ? event.reason.message : "" : ""}`;

        if (shouldIgnoreeClientError(eventMsg, "", 0, 0, event.reason)) {
            return false;
        }

        if (eventMsg || typeof event.reason === "object")
        {
            logError(`unhandledrejection: ${eventMsg}`,"","","",event.reason);
        }
        return false;
    };

    //note - disabled it in the settings as except of the URL of the page where there was an erorr - most errors we got here were garbage
    if (cxGlobal.initData.cLogger.logAllClientDeferredExceptions)
    {
        //https://github.com/jquery/jquery/blob/58c6ca9822afa42d3b40cca8edb0abe90a2bcb34/src/deferred/exceptionHook.js
        //override the default /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
        //that jQuery uses and show all thrown exceptions - problem here is noise - it will also show exceptions all places where we hooked to .fail(function(err){}..
        $.Deferred.exceptionHook = function(error, stack)
        {
            if (error || stack) //only log if there is actually something to log
            {
                if (typeof (error) === "string") //for throw("some message")
                {
                    error = { message : error };
                }
                error = error || {};
                error.stack = error.stack || stack || "no stack";
                logError("jQuery.Deferred ex: " + error.message, "", "", "", error);
            }
            // Support: IE 8 - 9 only
            // Console exists when dev tools are open, which can happen at any time
            //also log the error to the console since these errors will not be shown at the console like window.onerror errors
            if (window.console && window.console.warn)
            {
                window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
            }
        }
    }
    
}

//shared noise filter for both window.onerror and window.onunhandledrejection - url/lineNumber/column will be empty/0 when called for a promise rejection
function shouldIgnoreeClientError(errorMsg, url, lineNumber, column, errorObj) {
    //you will get "Script error." if somone use [throw "some message"] and not an error object (DONT DO THAT)
    //the user will see the "some message" in the console but we will get nothing but this generic error + no other details + sometimes it is thrown several times in conjuction with the real error
    //WE MIGHT want to enable this in the future so we can see that a user had a problem
    if (errorMsg === "Script error." && url === "" && lineNumber === 0 && column === 0 && errorObj === null) {
        return true; //NOTE - for users that set the language to one different from EN - the message will be in their language and this condition will be false
    }
    if (lineNumber === 0 && column === 0 && (errorMsg === "ResizeObserver loop limit exceeded" || errorMsg === "ResizeObserver loop completed with undelivered notifications.")) { //seems to be caused by a chrome extension and fluds our logs
        return true; //NOTE - for users that set the language to one different from EN - the message will be in their language and this condition will be false
    }
    if (errorMsg && errorMsg.indexOf("acsbJS is not defined") !== -1 || errorObj && errorObj.message && errorObj.message.indexOf("acsbJS is not defined") !== -1) {
        return true; //don't log accessibe failed to load errors
    }
    if (errorMsg && errorMsg.indexOf("Invalid call to runtime.sendMessage") !== -1) {
        return true; //browser extension messaging error (e.g. "Tab not found") thrown with no stack/url to match on, not caused by our app
    }
    if (url && url.indexOf("acsbapp.com") !== -1) {
        return true; //don't log accessibe internal script errors
    }
    if (errorObj && errorObj.stack && errorObj.stack.indexOf("acsbapp.com") !== -1) {
        return true; //don't log accessibe internal script errors
    }
    //older browser versions (e.g., older Safari versions) - event.reason isn't always a proper Error with a stack, so also check the whole stringified object
    if (errorObj && JSON.stringify(errorObj).indexOf("acsbapp.com") !== -1) {
        return true;
    }
    if (errorObj && errorObj.stack && errorObj.stack.indexOf("@webkit-masked-url:") !== -1) {
        return true; //don't log Safari browser extension https://stackoverflow.com/a/74216043/1873002
    }
    if (url && url.indexOf("chrome-extension") !== -1) {
        console.warn("We don't log Chrome extensions errors, but warn here so users can see it in case it effects the app", errorMsg, url, lineNumber, column, errorObj)
        return true;
    }
    if (!url && errorObj && errorObj.stack && errorObj.stack.indexOf("chrome-extension") !== -1) {
        console.warn("We don't log Chrome extensions errors, but warn here so users can see it in case it effects the app, here url was empty but the stack showed the source of the error", errorMsg, url, lineNumber, column, errorObj)
        return true;
    }
    //check if the error is a PDFJS error on unsupported browsers
    if (checkForPDFJSErrorOnUnspportedBrowser(errorMsg, errorObj)){
        console.warn("We don't log PDFJS errors on unsupported browsers, but warn here so users can see it in case it effects the app", errorMsg, url, lineNumber, column, errorObj)
        return true;
    }
    // Ignore "Maximum call stack size exceeded" errors, which can be noisy, especially on mobile browsers.
    if (checkForMaximumCallStackSizeExceededError(errorMsg, url)) {
        // Add a check for the stack to be more specific, as some browsers provide a repetitive, non-descriptive stack for this error.
        console.warn("Ignoring 'Maximum call stack size exceeded' error with a repetitive stack.", errorMsg, url, lineNumber, column, errorObj);
        return true;
    }
    return false;
}
function logError(errorMsg, url, lineNumber, column, errorObj) {
    var localDetails = {
        "rawUrl": window.location.href,
        "userAgent": navigator.userAgent,
        "appVersion": navigator.appVersion,
        "errorMsg": errorMsg,
        "url": url,
        "line number": lineNumber,
        "column": column
    };
    if (window.dskApp) {
        localDetails.candexAppVersion = window.dskApp.version ? window.dskApp.version : "really old one";
        localDetails.candexAppPlatform = window.dskApp.platform ? window.dskApp.platform : "probably windows";
        localDetails.candexAppOS = window.dskApp.os ? window.dskApp.os : "probably some windows os";
    }
    if (cxGlobal.initData.cLogger.disableLogger === true) {
        if (window.console && window.console.warn) {
            window.console.warn("cxError, no logger: ", localDetails, errorObj);
        }
    } else if (jsnlog && jsnlog.JL) {
        jsnlog.JL("onerrorLogger").fatalException(localDetails, errorObj);
    }
    else {
        logErrorWithNoLogger(localDetails, errorObj);
    }
}
function logErrorWithNoLogger(errorDetails, errorObj) {
    var flatDetails = "JL:false|";//jsnlog also stringify the details, also add a first key to note this msg is not from jsnlog
    for (var key in errorDetails) {
        if (errorDetails.hasOwnProperty(key)) {
            flatDetails += key + ":" + errorDetails[key] + "| ";
        }
    }
    if (errorObj !== null && typeof (errorObj) === "object") {
        flatDetails += " e.message:" + errorObj.message;
        flatDetails += " e.stack:" + errorObj.stack;
    }
    $.ajax({
        url: cxGlobal.initData.cLogger.loggerUrl,
        type: "POST",
        data: JSON.stringify([{ "n": (errorDetails && errorDetails.logAsDebug === true) ? "logAsDebug" : "" , "t": (new Date).getTime(), "m": flatDetails, "l": 5000 }]),
        headers: {
            "Content-Type": "application/json",
            "JSNLog-RequestId": cxGlobal.initData.cLogger.requestId,
            "UnixDates": true
        }
    });
}
function checkForPDFJSErrorOnUnspportedBrowser(errorMsg, errorObj) {
    // This error occurs on older Safari versions that do not support modern JavaScript syntax used in the pdf.js library.
    const isSyntaxError = errorMsg.includes("SyntaxError: Unexpected token '{'") || (errorObj && errorObj.name === 'SyntaxError' && errorObj.message === "Unexpected token '{'");
    const isPDFJSError = (errorObj && errorObj.sourceURL && errorObj.sourceURL.includes("cxPDFJSBundle.js"));
    return isSyntaxError && isPDFJSError;
}
function checkForMaximumCallStackSizeExceededError(errorMsg, url) {
    return errorMsg && errorMsg.includes("Maximum call stack size exceeded") && (!url || url === "undefined");
}
export function customLogError(errorMsg, errorObj) {
    logError(errorMsg, document.location.href, 0, 0, errorObj || new Error());
}